module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user"
  }, [_vm._m(0), _vm._v(" "), (!_vm.user) ? _c('div', {
    staticClass: "loading-holder"
  }, [_c('h3', [_vm._v("Loading Data...")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-progress mdl-js-progress mdl-progress__indeterminate"
  }), _vm._v(" "), _c('h4', [_vm._v("Please wait!")])]) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('div', {
    staticClass: "user-card mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-color--primary"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.user.display))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-grid",
    class: {
      blurred: _vm.state == 'saving'
    }
  }, [_c('div', {
    staticClass: "mdl-cell mdl-cell--9-col mdl-cell--12-col-phone"
  }, [_c('p', [_vm._v("User Id: " + _vm._s(_vm.user.id))]), _vm._v(" "), _c('p', [_vm._v("Display name: \"" + _vm._s(_vm.user.display) + "\"")]), _vm._v(" "), _c('div', {
    staticClass: "props"
  }, [_vm._l((_vm.userDataProps), function(prop, index) {
    return _c('div', {
      staticClass: "prop"
    }, [_c('div', {
      staticClass: "field mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (prop.key),
        expression: "prop.key"
      }],
      ref: 'userData_key_' + prop.key,
      refInFor: true,
      staticClass: "mdl-textfield__input",
      attrs: {
        "type": "text",
        "id": 'userData_key_' + prop.key,
        "required": _vm.required
      },
      domProps: {
        "value": (prop.key)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(prop, "key", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "mdl-textfield__label",
      attrs: {
        "for": 'userData_key_' + prop.key
      }
    }, [_vm._v("Field")])]), _vm._v(" "), (_vm.propType(prop) == 'text') ? _c('div', {
      staticClass: "field mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (prop.value),
        expression: "prop.value"
      }],
      ref: 'userData_value_' + prop.key,
      refInFor: true,
      staticClass: "mdl-textfield__input",
      attrs: {
        "type": "text",
        "id": 'userData_value_' + prop.key,
        "required": _vm.required
      },
      domProps: {
        "value": (prop.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(prop, "value", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "mdl-textfield__label",
      attrs: {
        "for": 'userData_value_' + prop.key
      }
    }, [_vm._v(_vm._s(prop.key))])]) : _vm._e(), _vm._v(" "), (_vm.propType(prop) == 'phone') ? _c('PhoneInput', {
      staticClass: "phoneNumber field",
      attrs: {
        "value": prop.value,
        "required": _vm.required,
        "invalid": false,
        "label": prop.key
      },
      on: {
        "update:value": function($event) {
          _vm.$set(prop, "value", $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.propType(prop) == 'country') ? _c('CountryInput', {
      staticClass: "country field",
      attrs: {
        "value": prop.value,
        "required": _vm.required,
        "invalid": false,
        "label": prop.key
      },
      on: {
        "update:value": function($event) {
          _vm.$set(prop, "value", $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent",
      on: {
        "click": function($event) {
          _vm.deleteProp(index)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("delete_forever")])]), _vm._v(" "), _c('br')], 1)
  }), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent",
    on: {
      "click": _vm.addProp
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--3-col mdl-cell--12-col-phone"
  }, [_c('h6', [_vm._v("Roles:")]), _vm._v(" "), _vm._l((_vm.possibleRoles), function(role) {
    return _c('div', {
      staticClass: "role-switch",
      on: {
        "click": function($event) {
          _vm.toggleRole(role)
        }
      }
    }, [_c('span', [(_vm.roles.indexOf(role) != -1) ? _c('i', {
      staticClass: "material-icons"
    }, [_vm._v("check_box")]) : _vm._e(), _vm._v(" "), (_vm.roles.indexOf(role) == -1) ? _c('i', {
      staticClass: "material-icons"
    }, [_vm._v("check_box_outline_blank")]) : _vm._e()]), _vm._v(" "), _c('span', [_vm._v(_vm._s(role))])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__actions mdl-card--border right-actions",
    class: {
      blurred: _vm.state == 'saving'
    }
  }, [_c('button', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    attrs: {
      "disabled": !_vm.userChanged
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": _vm.openRemoveDialog
    }
  }, [_vm._v("\n        Remove\n      ")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand mdl-grid",
    class: {
      blurred: _vm.state == 'saving'
    }
  }, [_vm._l((_vm.user.loginMethods), function(loginMethod) {
    return _c('div', {
      staticClass: "mdl-cell-6-col"
    }, [_c('div', {
      staticClass: "login-method mdl-card mdl-shadow--2dp"
    }, [_c('div', {
      staticClass: "mdl-card__title mdl-color--primary"
    }, [_vm._v("\n            " + _vm._s(loginMethod.type) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "mdl-card__supporting-text"
    }, [_c('p', [_vm._v(_vm._s(loginMethod.id))])]), _vm._v(" "), _c('div', {
      staticClass: "mdl-card__actions mdl-card--border"
    }, [(loginMethod.type == 'emailPassword') ? _c('a', {
      staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
      on: {
        "click": function($event) {
          _vm.openRemoveEmailDialog(loginMethod)
        }
      }
    }, [_vm._v("\n              Remove\n            ")]) : _vm._e(), _vm._v(" "), (loginMethod.type == 'emailPassword') ? _c('a', {
      staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
      on: {
        "click": function($event) {
          _vm.openChangeEmailPasswordDialog(loginMethod)
        }
      }
    }, [_vm._v("\n              Change password\n            ")]) : _vm._e()])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell-6-col"
  }, [_c('div', {
    staticClass: "add-login-method",
    on: {
      "click": _vm.openAddEmailPasswordDialog
    }
  }, [_vm._m(2), _vm._v(" "), _c('span', [_vm._v("Add Email/password")])])])], 2)]) : _vm._e(), _vm._v(" "), (_vm.confirmDialog) ? _c('div', {
    staticClass: "dialog-holder"
  }, [_c('div', {
    staticClass: "dialog mdl-card mdl-shadow--4dp"
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-color--accent"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.confirmDialog.title))]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent",
    on: {
      "click": _vm.closeDialog
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")])])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand"
  }, [_vm._v("\n        " + _vm._s(_vm.confirmDialog.text) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__actions mdl-card--border",
    class: {
      blurred: _vm.state == 'saving'
    }
  }, [_c('a', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("\n          Cancel\n        ")]), _vm._v(" "), _c('a', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": _vm.confirmDialog.action
    }
  }, [_vm._v("\n          " + _vm._s(_vm.confirmDialog.actionName || 'Ok') + "\n        ")])])])]) : _vm._e(), _vm._v(" "), (_vm.changeEmailPasswordDialog) ? _c('div', {
    staticClass: "dialog-holder",
    class: {
      blurred: this.state == 'saving'
    }
  }, [_c('div', {
    staticClass: "dialog mdl-card mdl-shadow--4dp"
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-color--accent"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v("Change password")]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent",
    on: {
      "click": function () { return _vm.changeEmailPasswordDialog = false; }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")])])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand"
  }, [(_vm.error) ? _c('div', {
    staticClass: "serverError"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword1),
      expression: "newPassword1"
    }],
    ref: "newPassword1",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "password",
      "id": "newPassword1"
    },
    domProps: {
      "value": (_vm.newPassword1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword1 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "newPassword2"
    }
  }, [_vm._v("New password")])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword2),
      expression: "newPassword2"
    }],
    ref: "newPassword2",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "password",
      "id": "newPassword2"
    },
    domProps: {
      "value": (_vm.newPassword2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "newPassword2"
    }
  }, [_vm._v("Retype password")]), _vm._v(" "), (_vm.notMatch) ? _c('span', {
    staticClass: "mdl-textfield__error"
  }, [_vm._v("Passwords does not match")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__actions mdl-card--border right-actions",
    class: {
      blurred: _vm.state == 'saving'
    }
  }, [_c('a', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": function () { return _vm.changeEmailPasswordDialog = false; }
    }
  }, [_vm._v("\n          Cancel\n        ")]), _vm._v(" "), _c('a', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": _vm.changeEmailPassword
    }
  }, [_vm._v("\n          Change password\n        ")])])])]) : _vm._e(), _vm._v(" "), (_vm.addEmailPasswordDialog) ? _c('div', {
    staticClass: "dialog-holder",
    class: {
      blurred: this.state == 'saving'
    }
  }, [_c('div', {
    staticClass: "dialog mdl-card mdl-shadow--4dp"
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-color--accent"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v("Change password")]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent",
    on: {
      "click": function () { return _vm.addEmailPasswordDialog = false; }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")])])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand"
  }, [(_vm.error) ? _c('div', {
    staticClass: "serverError"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield&#45;&#45;floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEmail),
      expression: "newEmail"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "email",
      "id": "email"
    },
    domProps: {
      "value": (_vm.newEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newEmail = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("New email")])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword1),
      expression: "newPassword1"
    }],
    ref: "newPassword1",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "password",
      "id": "newPassword1"
    },
    domProps: {
      "value": (_vm.newPassword1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword1 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "newPassword2"
    }
  }, [_vm._v("New password")])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword2),
      expression: "newPassword2"
    }],
    ref: "newPassword2",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "password",
      "id": "newPassword2"
    },
    domProps: {
      "value": (_vm.newPassword2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "newPassword2"
    }
  }, [_vm._v("Retype password")]), _vm._v(" "), (_vm.notMatch) ? _c('span', {
    staticClass: "mdl-textfield__error"
  }, [_vm._v("Passwords does not match")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__actions mdl-card--border",
    class: {
      blurred: _vm.state == 'saving'
    }
  }, [_c('a', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": function () { return _vm.addEmailPasswordDialog = false; }
    }
  }, [_vm._v("\n          Cancel\n        ")]), _vm._v(" "), _c('a', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": _vm.addEmailPassword
    }
  }, [_vm._v("\n          Add email/password\n        ")])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "demo-header mdl-layout__header mdl-color--grey-100 mdl-color-text--grey-600"
  }, [_c('div', {
    staticClass: "mdl-layout__header-row"
  }, [_c('span', {
    staticClass: "mdl-layout-title"
  }, [_vm._v("User")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-layout-spacer"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-card__title mdl-color--primary"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v("Authentication methods:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--colored"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-035c9c3b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User.vue
// module id = 408
// module chunks = 1